import React from "react";
import useApi from "../useApi";
import LocalidadeApiClient from "../../api/localidade";

export default function useLocalidade(estado = null) {
  const [estados, setEstados] = React.useState({});
  const [municipios, setMunicipios] = React.useState({});

  const getMunicipiosCb = React.useCallback(() => {
    return LocalidadeApiClient.listMunicipios(estado);
  }, [estado]);

  const { request: getMunicipios, data: municipiosResponse } =
    useApi(getMunicipiosCb);

  const { request: getEstados } = useApi(LocalidadeApiClient.listEstados);
  const { request: getCep, data: cepResponse } = useApi(
    LocalidadeApiClient.buscaCep
  );

  //Busca estados ao renderizar tela
  React.useEffect(() => {
    const buscarEstados = async () => {
      var estadosResponse = await getEstados();
      if (!estadosResponse) return;
      setEstados(() => ({
        ...estadosResponse,
      }));
    };
    buscarEstados();
  }, [getEstados, setEstados]);

  //Define estado municipios ao receber municipios
  React.useEffect(() => {
    if (!municipiosResponse) return;
    setMunicipios(() => ({ ...municipiosResponse }));
  }, [municipiosResponse, setMunicipios]);

  return { estados, municipios, getMunicipios, getCep, cepResponse };
}
